import type { Element, Point, LineElement, ArrowElement } from '@/types';

const CONTROL_POINT_HIT_TOLERANCE = 8;

export interface ControlPointInfo {
  elementId: string;
  pointIndex: number;
}

/**
 * Finds a control point (for lines/arrows) at a given canvas point.
 * @param point - The point to check.
 * @param elements - All elements on the canvas.
 * @param selectedIds - The map of selected element IDs.
 * @returns The element and the index of the control point if found, otherwise null.
 */
export function getControlPointAtPoint(
  point: Point,
  elements: Element[],
  selectedIds: Map<string, boolean>
): ControlPointInfo | null {
  // Iterate backwards to check topmost elements first since they are rendered last
  for (let i = elements.length - 1; i >= 0; i--) {
    const element = elements[i];
    if (element && (element.type === 'line' || element.type === 'arrow')) {
      const lineOrArrow = element as LineElement | ArrowElement;
      if (lineOrArrow.points && selectedIds.has(element.id)) {
        // Only check selected elements
        for (let j = 0; j < lineOrArrow.points.length; j++) {
          const controlPoint = lineOrArrow.points[j];
          if (controlPoint) {
            const distance = Math.sqrt(
              Math.pow(point.x - controlPoint.x, 2) +
                Math.pow(point.y - controlPoint.y, 2)
            );

            if (distance < CONTROL_POINT_HIT_TOLERANCE) {
              return {
                elementId: element.id,
                pointIndex: j,
              };
            }
          }
        }
      }
    }
  }
  return null;
}
